import React, { memo, useCallback, useMemo } from 'react'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { SxProps } from '@mui/material'
import { selectClientLabels } from '../../../features/DisplayClientLabels'
import { MuiAutocomplete } from '../../../shared/ui/MuiAutocomplete/MuiAutocomplete'

interface LabelFilterProps {
	dispatcher: Function
	value: string | undefined
	className?: string;
	styles?: SxProps
}

export const LabelName = memo((props: LabelFilterProps) => {
	const {
		dispatcher,
		value,
		className,
		styles
	} = props

	const clientLabels = useAppSelector(selectClientLabels)

	const handleLabelNameInputChange = useCallback((value: string) => {
		dispatcher(value)
	}, [dispatcher])

	const labelNameOptions = useMemo(
		() => clientLabels.map(label => label.labelName
		), [clientLabels])

	return (
		<MuiAutocomplete
			onInputChange={handleLabelNameInputChange}
			options={labelNameOptions}
			label={'Label name'}
			className={className}
			styles={styles}
			value={value}
		/>
	)
})
